import { discardPromise } from "@warrenio/utils/promise/discardPromise";
import { useCallback, useState } from "react";
import { isPromise } from "remeda";

export interface PromiseLoadingHook {
    isPromiseLoading: boolean;
    trackPromise: (action: () => void | Promise<void>, onError: (e: unknown) => void) => void;
}

export function usePromiseLoading(): PromiseLoadingHook {
    const [promisePendingCount, setPromisePendingCount] = useState(0);
    const trackPromise = useCallback<PromiseLoadingHook["trackPromise"]>((action, onError) => {
        try {
            const promise = action();
            if (isPromise(promise)) {
                setPromisePendingCount((count) => count + 1);
                discardPromise(
                    promise
                        .finally(() => {
                            setPromisePendingCount((count) => count - 1);
                        })
                        .catch(onError),
                );
            }
        } catch (e) {
            onError(e);
        }
    }, []);

    return { isPromiseLoading: promisePendingCount > 0, trackPromise };
}
